import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

const SWorkSamples = styled(({ ...rest }) => <motion.div {...rest} />)`
  ${(props) => props.theme.layout.wrapperMobile};
  ${(props) => props.theme.layout.routeMotion};
  height: 100vh;
  background: white;
  @media screen and (min-width: ${(props) => props.theme.breakpoints.laptop}) {
    ${(props) => props.theme.layout.wrapper};
  }
`;

const SSlideshow = styled.div`
  position: relative;
  width: 100%;
  height: 80vh;
  @media screen and (min-width: ${(props) => props.theme.breakpoints.laptop}) {
  }
`;

const SSlideContent = styled(({ ...rest }) => <motion.div {...rest} />)`
  width: 100%;
  position: absolute;
  @media screen and (min-width: ${(props) => props.theme.breakpoints.laptop}) {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    img {
      z-index: 2;
    }
  }
`;

const SSlideHeader = styled.header`
  width: 100%;
  text-align: center;
  margin-bottom: ${(props) => props.theme.spacing.rem(6)};
`;

const SSlideMain = styled.main`
  width: 100%;
  padding: ${(props) => props.theme.spacing.rem(2)};
  background: ${(props) => props.theme.color.muted.main};
  @media screen and (min-width: ${(props) => props.theme.breakpoints.laptop}) {
    padding: ${(props) => props.theme.spacing.baseline(4, 4, 2, 10)};
    width: 50%;
    margin-left: -5%;
  }
`;

const SSlideSpecs = styled.ul`
  margin: ${(props) => props.theme.spacing.rem(3, 0, 3, -1)};
`;

const SSlideTags = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${(props) => props.theme.spacing.rem(2)};
  list-style: circle;
  list-style-position: inside;
  li {
    width: 40%;
    margin: ${(props) => props.theme.spacing.baseline(0, 3, 0.5, 0)};
  }
  @media screen and (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    li {
      width: auto;
    }
  }
`;

const SNav = styled.button`
  position: absolute;
  top: 30%;
  z-index: 3;
  transform: translate(0, -50%);
  width: ${(props) => props.theme.spacing.rem(8)};
  height: ${(props) => props.theme.spacing.rem(8)};
  border: 2px solid ${(props) => props.theme.color.accent.main};;
  background: white;
  border-radius: 50%;
  color: ${(props) => props.theme.color.accent.main};
  &:hover {
    color: ${(props) => props.theme.color.caption};
    border-color: ${(props) => props.theme.color.caption};
    transition: color ${(props) => props.theme.transition.fast};
  }
  ${({ next }) => {
    if (next)
      return css`
        right: ${(props) => props.theme.spacing.rem(2)};
      `;
    return css`
      left: 0;
    `;
  }}
  @media screen and (min-width: ${(props) => props.theme.breakpoints.laptop}) {
    top: 50%;
  }
`;

const SDots = styled.ul`
  display: none;
  @media screen and (min-height: ${(props) => props.theme.breakpoints.tablet}) {
    position: absolute;
    top: 100%;
    display: block;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

const SDotItem = styled.li`
  margin-right: ${(props) => props.theme.spacing.rem(2)};
`;

const SDotButton = styled.button`
  width: ${(props) => props.theme.spacing.rem(3)};
  height: ${(props) => props.theme.spacing.rem(3)};
  border: 1px solid ${(props) => props.theme.color.accent.main};
  border-radius: 50%;
  text-indent: -800px;
  overflow: hidden;
  ${({ isActive }) => {
    if (isActive) {
      return css`
        border-color: ${(props) => props.theme.color.accent.main};
        background: ${(props) => props.theme.color.accent.main};
      `;
    }
    return false;
  }}
`;

export {
  SWorkSamples,
  SSlideshow,
  SNav,
  SSlideContent,
  SSlideHeader,
  SSlideMain,
  SSlideSpecs,
  SSlideTags,
  SDots,
  SDotItem,
  SDotButton,
};
